export default __webpack_public_path__ + "static/media/icon_tick_white.adf58e89.svg";